__turbopack_context__.v({
  "amount": "payment-options-module-scss-module__VJ-ozq__amount",
  "amountToPayWrapper": "payment-options-module-scss-module__VJ-ozq__amountToPayWrapper",
  "checked": "payment-options-module-scss-module__VJ-ozq__checked",
  "close": "payment-options-module-scss-module__VJ-ozq__close",
  "icon-american-express": "payment-options-module-scss-module__VJ-ozq__icon-american-express",
  "icon-arrow": "payment-options-module-scss-module__VJ-ozq__icon-arrow",
  "icon-chat": "payment-options-module-scss-module__VJ-ozq__icon-chat",
  "icon-cross": "payment-options-module-scss-module__VJ-ozq__icon-cross",
  "icon-discover": "payment-options-module-scss-module__VJ-ozq__icon-discover",
  "icon-mastercard": "payment-options-module-scss-module__VJ-ozq__icon-mastercard",
  "icon-visa": "payment-options-module-scss-module__VJ-ozq__icon-visa",
  "label": "payment-options-module-scss-module__VJ-ozq__label",
  "location": "payment-options-module-scss-module__VJ-ozq__location",
  "note": "payment-options-module-scss-module__VJ-ozq__note",
  "open": "payment-options-module-scss-module__VJ-ozq__open",
  "phone": "payment-options-module-scss-module__VJ-ozq__phone",
  "radioIcon": "payment-options-module-scss-module__VJ-ozq__radioIcon",
  "radioLabel": "payment-options-module-scss-module__VJ-ozq__radioLabel",
  "textInput": "payment-options-module-scss-module__VJ-ozq__textInput",
  "textInputWrapper": "payment-options-module-scss-module__VJ-ozq__textInputWrapper",
  "trade-mark": "payment-options-module-scss-module__VJ-ozq__trade-mark",
});
